import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { OrganisationTokenQueryKeys } from './queryKeys';
import { IOrganisationToken } from '../../types/OrganisationToken/OrganisationToken';

export default function useOrganisationTokens() {
  const { get } = useApiHelper();

  const organisationTokens = useQuery({
    queryKey: OrganisationTokenQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponseWithData<IOrganisationToken>>('/v1/organisation/tokens').then(
        (res) => res.data.data
      ),
  });

  return {
    organisationTokens,
  };
}
